module.exports = {
  MPA_TRANSACTIONS_DELETE_REQUEST: 'MPA_TRANSACTIONS_DELETE_REQUEST',
  MPA_TRANSACTIONS_DELETE_SUCCESS: 'MPA_TRANSACTIONS_DELETE_SUCCESS',
  MPA_TRANSACTIONS_DELETE_FAILURE: 'MPA_TRANSACTIONS_DELETE_FAILURE',
};
